import React, { useContext, useEffect, useState } from 'react'
import { WorkflowContext, WorkflowContextPayload } from '../../../../../../context/workflowContext';
import { Autocomplete, Chip, Divider, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import style from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"; 
import contactStyle from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import workflowStyles from '../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import waCampaignStyles from "../../../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss"; 
import workflowCreateStyles from "../../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss" 
import textAreaStyles from '../../../../../../assets/styles/componentStyles/templates.module.scss'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../../context/flowBuilderContext';
import { chatbotTriggerConfigs, condition_group_trigger_configs, delayTimeObj, operatorType, triggerConfigs } from '../../../../../../models/flowBuilderTypes';
import { isCurrentViewVersionPublished } from '../../../utilityFunctions';
import Required from '../../../../../utility/required';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import { customVariableDataInterface } from '../../../../../../models/axiosModel';
import { useFlowBuilderStore } from '../../../../../../store/flowBuilderStore';
import CloseIcon from '@mui/icons-material/Close';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import GlobalButton from '../../../../../utility/globalButton/button';
import { delayTimeOptions, emptyConditionGroupObj, emptyCustomVariableConditionObj, getCurrentViewVersionsTriggers, getCustomVariableById, getDelayObjByValue, OPERATOR_TYPES, operatorTypesWithEmptyValue } from '../../../flowBuilderConstants';
import { checkValidRegex } from '../../../../../../utils/constants';
import PrimaryIOSSwitch from '../../../../../utility/switch/primaryIOSSwitch';
dayjs.extend(utc);

interface SmartDelayPopupProps {
    getStepTriggers:  () => triggerConfigs[],
    selectedTrigger: triggerConfigs,
    setSelectedTrigger: React.Dispatch<React.SetStateAction<triggerConfigs>>,
    setFlagSmartDelayPopup: React.Dispatch<React.SetStateAction<boolean>>,
    updateChatbotTriggerConfigs: (trigger_configs: triggerConfigs[]) => Promise<void>,
    getStepNameByStepId: (id: string, defaultValue: string) => string, 
    flagStepLevel: boolean,
    stepId?: string,
} 

type CombinedUpdateValueType = "operator" | "variable" | "value" | "freesolo value" | "delay time" | "flag on inactivity" | "target chatbot step" | "condition switch";

type CombinedUpdateType =
  | { type: "variable"; value: customVariableDataInterface | null }
  | { type: "operator"; value: operatorType | null }
  | { type: "value"; value: string }
  | { type: "delay time"; value: delayTimeObj | null }
  | { type: "flag on inactivity"; value: string }
  | { type: "target chatbot step"; value: any}
  | { type: "condition switch"; value: boolean};

const SmartDelayPopup: React.FC<SmartDelayPopupProps> = (props) => {
    
    const { getStepTriggers, selectedTrigger, setSelectedTrigger, setFlagSmartDelayPopup, updateChatbotTriggerConfigs, flagStepLevel, getStepNameByStepId, stepId } = props;

    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload; 
    const { nodes, operatorList, getOperatorTypeApi } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload 

    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)
    const chatbotTriggerConfigs = useFlowBuilderStore((store) => store.chatbotTriggerConfigs);

    const [typedConditionValue, setTypedConditionValue] = useState<string>("");
    const [flagSameTriggerExist, setFlagSameTriggerExist] = useState<boolean>(false);

    const getOperatorTypeApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getOperatorTypeApi();
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => { 
        if (!operatorList) {
            getOperatorTypeApiCall();
        }
    }, []);

    const getFieldValues = (type: CombinedUpdateValueType) => {
        const { condition_group } = selectedTrigger;

        switch(type){
            case "delay time": 
                return getDelayObjByValue(selectedTrigger?.trigger_after_time_ms);
            case "target chatbot step": 
                return nodes?.find((node: any) => node?.id == (selectedTrigger?.target_chatbot_step_id ?? ""));
            case "flag on inactivity":
                return selectedTrigger?.flag_trigger_on_inactivity;
            case "variable": 
                return getCustomVariableById(customVariableList, condition_group?.custom_variable_conditions?.chatbot_custom_variable_configuration_id) || null;
            case "operator": 
                return operatorList?.filter((operator) => operator.is_active).find((operator) => operator.operator_type_id == condition_group?.custom_variable_conditions?.operator_type_id) || null;
            case "value": 
                return condition_group?.custom_variable_conditions?.condition_value || "";
            case "freesolo value": 
                return (condition_group?.custom_variable_conditions?.condition_value || "")?.split(",")?.map((item: string) => item?.trim())?.filter((item: string) => item?.length > 0) ?? [];
            case "condition switch":
                return condition_group ? true : false;
        }
    }

    const onChangeOfFields = ({type, value}: CombinedUpdateType) => {
        setSelectedTrigger((prev) => {
            if (!prev) return prev as triggerConfigs; 
            let newTrigger = { ...prev };

            const ensureConditionGroup = (): condition_group_trigger_configs => {
                if (prev?.condition_group) {
                    return prev.condition_group;
                }
                return emptyConditionGroupObj;
            };

            const baseConditions = {
                ...emptyCustomVariableConditionObj,
                ...(prev?.condition_group?.custom_variable_conditions ?? {}),
            };

            let updatedConditions = baseConditions;
            switch(type){
                case "delay time":
                    return {
                        ...newTrigger,
                        trigger_after_time_ms: value ? value?.value : 0,
                    }
                case "target chatbot step": 
                    return {
                        ...newTrigger, 
                        target_chatbot_step_id: value ? value?.id : "",
                    }
                case "flag on inactivity":
                    return {
                        ...newTrigger, 
                        flag_trigger_on_inactivity: value == "true",
                    }
                case "variable": 
                    updatedConditions = {
                        ...baseConditions,
                        chatbot_custom_variable_configuration_id:
                            value ? value?.chatbot_custom_variable_configuration_id : "",
                    };
                    break;
                case "operator":
                    const opVal = value as operatorType | null;
                    
                    updatedConditions = {
                        ...baseConditions,
                        operator_type_id: opVal ? opVal.operator_type_id : "",
                        operator_type_name: opVal ? opVal.operator_type_name : "",
                    };

                    // Empty value operators
                    if (opVal && operatorTypesWithEmptyValue.includes(opVal.operator_type_name)) {
                        updatedConditions.condition_value = "";
                    }
                    break;
                case "value":
                    updatedConditions = {
                        ...baseConditions,
                        condition_value: value,
                    };
                    break;
                case "condition switch":
                    return {
                        ...newTrigger,
                        condition_group: value ? emptyConditionGroupObj : null,
                    }
            }
            const conditionGroup = ensureConditionGroup();
            return {
                ...newTrigger, 
                condition_group: { 
                    ...conditionGroup,
                    custom_variable_conditions: updatedConditions,
                },
            }
        })

        if(flagSameTriggerExist) setFlagSameTriggerExist(false);
    }

    const isOperatorWithEmptyValueSelected = () => {
        return operatorTypesWithEmptyValue?.includes((getFieldValues("operator") as operatorType | null)?.operator_type_name?.toLowerCase() ?? "");
    }

    const checkIfSameTriggerAlreadyConfigured = () => {
        const triggers = getStepTriggers();

        const sameTriggerExist = triggers?.filter((trigger) => trigger?.chatbot_timeout_trigger_config_id != selectedTrigger?.chatbot_timeout_trigger_config_id).some((trigger) => {
            const condition = trigger?.condition_group?.custom_variable_conditions ?? null;

            const { custom_variable_conditions } = selectedTrigger?.condition_group ?? {};
            return (
                trigger?.trigger_after_time_ms == selectedTrigger?.trigger_after_time_ms && 
                trigger?.flag_trigger_on_inactivity == selectedTrigger?.flag_trigger_on_inactivity && 
                trigger?.target_chatbot_step_id == selectedTrigger?.target_chatbot_step_id && 
                (condition?.chatbot_custom_variable_configuration_id ?? "") == (custom_variable_conditions?.chatbot_custom_variable_configuration_id ?? "") && 
                (condition?.operator_type_id ?? "") == (custom_variable_conditions?.operator_type_id ?? "") && 
                (condition?.condition_value ?? "") == (custom_variable_conditions?.condition_value ?? "")
            )
        })

        if(sameTriggerExist){
            if(!flagSameTriggerExist) setFlagSameTriggerExist(true);
        } else {
            if(flagSameTriggerExist) setFlagSameTriggerExist(false);
        }
        return sameTriggerExist;
    }

    const checkDisableSaveBtn = () => {
        if(!selectedTrigger?.trigger_after_time_ms || !selectedTrigger?.target_chatbot_step_id){
            return true;
        }

        if(checkIfSameTriggerAlreadyConfigured()){
            return true;
        }

        if(!selectedTrigger?.condition_group){
            return false;
        }

        const { custom_variable_conditions } = selectedTrigger?.condition_group ?? {};

        const hasVariableInCondition = custom_variable_conditions?.chatbot_custom_variable_configuration_id; 
        const hasOperatorTypeInCondition =  custom_variable_conditions?.operator_type_name?.toLowerCase() ?? ""; 
        const hasConditionValueInCondition = custom_variable_conditions?.condition_value?.trim();
        
        const operatorIgnoreValues = operatorTypesWithEmptyValue.includes(hasOperatorTypeInCondition);
        const isRegexOperator = hasOperatorTypeInCondition == OPERATOR_TYPES["REGEX_MATCH"];

        if(operatorIgnoreValues){
            if(!hasVariableInCondition || !hasOperatorTypeInCondition){
                return true; 
            }
            return false;
        }  

        if (isRegexOperator) {
            if (!hasVariableInCondition || !hasOperatorTypeInCondition || !hasConditionValueInCondition) {
                return true;
            }
            if (!checkValidRegex(hasConditionValueInCondition)) {
                return true;
            }
            return false;
        }

        const allFieldExist = hasVariableInCondition && hasOperatorTypeInCondition && hasConditionValueInCondition;
        if(!(allFieldExist)){
            return true;
        }

        return false;
    }

    const onClickOfSaveBtn = async () => {
        let trigger_configs: triggerConfigs[] = [];
        const triggers: chatbotTriggerConfigs | undefined = getCurrentViewVersionsTriggers(chatbotTriggerConfigs, currentActiveStaticWorkflow);
        if(triggers){
            const current_trigger = triggers.trigger_configs?.find((trigger) => trigger?.chatbot_timeout_trigger_config_id == selectedTrigger?.chatbot_timeout_trigger_config_id);
            const normalizedSelectedTrigger: triggerConfigs = {
                ...selectedTrigger,
                condition_group: selectedTrigger?.condition_group?.custom_variable_conditions?.chatbot_custom_variable_configuration_id ? selectedTrigger?.condition_group : null
            }
            if(current_trigger){
                trigger_configs = triggers.trigger_configs?.map((trigger) => {
                    if(trigger?.chatbot_timeout_trigger_config_id == selectedTrigger?.chatbot_timeout_trigger_config_id){
                        return normalizedSelectedTrigger;
                    }
                    return trigger;
                })
            } else {
                trigger_configs = [...triggers.trigger_configs, normalizedSelectedTrigger];
            }
        }

        await updateChatbotTriggerConfigs(trigger_configs);
        setFlagSmartDelayPopup(false);
    }

    const getConfigureSmartDelayPopupTitle = () => {
        const titlePrefix = "Configure Smart Delay at";
        if(flagStepLevel){
            return `${titlePrefix} ${getStepNameByStepId(stepId ?? "", "This Step")}`;
        } else {
            return `${titlePrefix} Chatbot Level`;
        }
    }

    const renderFormControlLabel = (label: string, value: boolean) => {
        return (
            <FormControlLabel 
                className={globalStyles.radioLabelStyle} 
                value={value} 
                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)} 
                control={<Radio className={globalStyles.radioButton} />} 
                label={label}
            />
        );
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={style.popupTitleTypography}>
                                {getConfigureSmartDelayPopupTitle()}
                            </Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />  

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={style.popupBodyGridContainer} gap={2}>

                                <Grid item className={globalStyles.fullwidth} xs={12}>
                                    <Grid container gap={2} direction={"column"}>
                                        <Grid item xs={12}>
                                            <Grid container gap={"6px"}>
                                                <Grid item xs={12}>
                                                    <Typography className={contactStyle.popupFieldTypography}>Delay Time <Required /></Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <TimePicker
                                                            ampm={false} 
                                                            views={['hours', 'minutes', 'seconds']}
                                                            format="HH:mm:ss"
                                                            value={getFieldValues("delay time")}
                                                            className={workflowStyles.delayTimerField}
                                                            minutesStep={1}
                                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                            onChange={(value) => onChangeOfFields({type: "delay time", value: value})}
                                                        />
                                                    </LocalizationProvider> */}

                                                    <Autocomplete
                                                        className={globalStyles.autocompleteParaphrasing}
                                                        options={(delayTimeOptions || []) as delayTimeObj[]}
                                                        getOptionLabel={(option: delayTimeObj) => option?.label || ""}
                                                        renderInput={(params) => <TextField {...params} placeholder='Select Delay Time' />}
                                                        value={getFieldValues('delay time')}
                                                        onChange={(e, value) => onChangeOfFields({ type: "delay time", value: value })}
                                                        disabled={flagStepLevel ? isCurrentViewVersionPublished(currentActiveStaticWorkflow) : false}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Grid container gap={"6px"}>
                                                <Grid item xs={12}>
                                                    <Typography className={contactStyle.popupFieldTypography}>Chatbot Step  <Required /></Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Autocomplete
                                                        className={globalStyles.autocompleteParaphrasing}
                                                        options={nodes?.filter((node: any) => node?.type != "trigger")}
                                                        getOptionLabel={(option) => option?.chatbot_step_name || ""}
                                                        renderInput={(params) => <TextField {...params} placeholder='Select Chatbot Step to Re-Direct' />}
                                                        value={getFieldValues('target chatbot step')}
                                                        onChange={(e, value) => onChangeOfFields({ type: "target chatbot step", value: value })}
                                                        disabled={flagStepLevel ? isCurrentViewVersionPublished(currentActiveStaticWorkflow) : false}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Grid container gap={"6px"}>
                                                <Grid item xs={12}>
                                                    <Typography className={contactStyle.popupFieldTypography}>Flag Trigger on Inactivity</Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <FormControl>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="flag-trigger-on-inactivity"
                                                            defaultValue=""
                                                            name="trigger-on-inactivity-buttons-group"
                                                            value={getFieldValues("flag on inactivity")}
                                                            onChange={(event) => onChangeOfFields({ type: "flag on inactivity", value: event.target.value })}
                                                        >
                                                            {renderFormControlLabel("True", true)}
                                                            {renderFormControlLabel("False", false)}
                                                        </RadioGroup>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Grid container gap={"6px"}>
                                                <Grid item xs={12}>
                                                    <Grid container className={globalStyles.displayFlex} gap={1}>
                                                        <Grid item>
                                                            <Typography className={contactStyle.popupFieldTypography}>Trigger Condition</Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            <PrimaryIOSSwitch
                                                                className={workflowCreateStyles.intentConditionSwitch}
                                                                checked={getFieldValues("condition switch") as boolean}
                                                                onChange={(e) => onChangeOfFields({ type: "condition switch", value: e.target.checked })}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                {getFieldValues("condition switch") && 
                                                    <Grid item xs={12}>
                                                        <Grid container gap={1} flexWrap={"nowrap"}>
                                                            <Grid item xs={isOperatorWithEmptyValueSelected() ? 6 : 4.5}>
                                                                <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                                                    <Grid item>
                                                                        <Typography className={style.popupFieldTypography}>Variable</Typography>
                                                                    </Grid>
                                                                    <Grid>
                                                                        <Autocomplete
                                                                            className={`${style.contactFilterDropdownsInPopup}`}
                                                                            options={customVariableList?.custom_variable_data || []}
                                                                            getOptionLabel={(option) => option.chatbot_custom_variable_name}
                                                                            value={getFieldValues("variable") as customVariableDataInterface | null}
                                                                            onChange={(_, value: customVariableDataInterface | null) => onChangeOfFields({ type: "variable", value: value })}
                                                                            renderInput={(params) => <TextField {...params} placeholder='Select Variable' />} 
                                                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>  

                                                            <Grid item xs={isOperatorWithEmptyValueSelected() ? 6 : 3}>
                                                                <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                                                    <Grid item>
                                                                        <Typography className={style.popupFieldTypography}>Operator</Typography>
                                                                    </Grid>
                                                                    <Grid>
                                                                        <Autocomplete
                                                                            className={`${style.contactFilterDropdownsInPopup}`}
                                                                            options={operatorList?.filter((operator) => operator.is_active) || []}
                                                                            getOptionLabel={(option) => option.operator_type_name}
                                                                            value={getFieldValues("operator") as operatorType | null}
                                                                            onChange={(_, value: operatorType | null) => onChangeOfFields({ type: "operator", value: value })}
                                                                            renderInput={(params) => <TextField {...params} placeholder='Operator' />}
                                                                            disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid> 

                                                            {!isOperatorWithEmptyValueSelected() && 
                                                                <Grid item xs={4}>
                                                                    <Grid container className={`${globalStyles.flexColumn}`} gap={"3px"}>
                                                                        <Grid item>
                                                                            <Typography className={style.popupFieldTypography}>Value</Typography>
                                                                        </Grid>
                                                                        <Grid>
                                                                            {(getFieldValues("operator") as operatorType | null)?.operator_type_name?.toLowerCase() == "contains in array" ?
                                                                                <Autocomplete   
                                                                                    className={`${waCampaignStyles.whatsappCampaignDropDowns} ${globalStyles.fullwidth} ${waCampaignStyles.actionAutoComplete} ${waCampaignStyles.actionUserReplyAutoComplete} ${workflowCreateStyles.triggerValueFreeSolo} ${workflowCreateStyles.conditionValueFreeSolo}`}
                                                                                    freeSolo
                                                                                    options={[]}
                                                                                    multiple
                                                                                    value={getFieldValues("freesolo value") as string[]}
                                                                                    inputValue={typedConditionValue} 
                                                                                    onInputChange={(e, val) => setTypedConditionValue(val)}
                                                                                    renderTags={(value, getTagProps) =>
                                                                                        value.map((option, index) => (
                                                                                            <Chip
                                                                                                label={option}
                                                                                                deleteIcon={<CloseIcon />}
                                                                                                {...getTagProps({ index })}
                                                                                                className={workflowCreateStyles.containsInArrayFieldChip}
                                                                                            />
                                                                                        ))
                                                                                    }
                                                                                    onChange={(e, newValue) => { 
                                                                                        const filtered = newValue.filter((val) => typeof val === "string" && val.trim().length > 0);
                                                                                        onChangeOfFields({ type: "value", value: filtered?.map((item) => item?.trim())?.filter((item) => item.length > 0)?.join(", ") ?? "" })
                                                                                    }} 
                                                                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                                                    renderInput={params => {
                                                                                        const { InputProps, ...restParams } = params;
                                                                                        const { startAdornment, ...restInputProps } = InputProps;
                                                                                        return (
                                                                                            <TextField
                                                                                                {...restParams}
                                                                                                placeholder='Enter Value' 
                                                                                                onBlur={() => {}}
                                                                                                InputProps={{
                                                                                                    ...restInputProps,
                                                                                                    startAdornment: (
                                                                                                        <div className={waCampaignStyles.renderInputDivOfUserReplyOfAction}>
                                                                                                            {startAdornment}
                                                                                                        </div>
                                                                                                    ),
                                                                                                }}
                                                                                            />
                                                                                        );
                                                                                    }}
                                                                                />
                                                                                :
                                                                                <textarea
                                                                                    value={getFieldValues("value") as string}
                                                                                    onChange={(e) => onChangeOfFields({ type: "value", value: e.target.value })}
                                                                                    placeholder="Enter Value"
                                                                                    className={`${textAreaStyles.templateGlobalTextarea} ${workflowCreateStyles.conditionValueTextArea}`} 
                                                                                    disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                                                />
                                                                            }
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                }
                                            </Grid>
                                        </Grid>

                                        {flagSameTriggerExist && 
                                            <Grid item xs={12}>
                                                <Typography className={workflowCreateStyles.sameIntentExistTypography}>
                                                    A smart delay with the same configuration already exists.
                                                </Typography>
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} mt={1} mb={1}>
                                    <Grid container justifyContent={"center"} alignItems={"center"} gap={2}>
                                        <GlobalButton
                                            className='borderedButtonStyle'
                                            buttonText="Cancel"
                                            sx={{ width: "120px" }}
                                            onClick={() => setFlagSmartDelayPopup(false)}
                                        />

                                        <GlobalButton
                                            className='primaryButtonStyle'
                                            buttonText='Save'
                                            sx={{ width: "120px" }}
                                            disabled={checkDisableSaveBtn()}
                                            onClick={() => onClickOfSaveBtn()}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default SmartDelayPopup
